
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hwrhg", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $cc1a958bd304f822$export$6503ec6e8aabbaf; }, function (v) { return $cc1a958bd304f822$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $cc1a958bd304f822$export$f7ad0328861e2f03; }, function (v) { return $cc1a958bd304f822$export$f7ad0328861e2f03 = v; });
var $cc1a958bd304f822$export$6503ec6e8aabbaf;
var $cc1a958bd304f822$export$f7ad0328861e2f03;
"use strict";
var $cc1a958bd304f822$var$mapping = new Map();
function $cc1a958bd304f822$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$cc1a958bd304f822$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $cc1a958bd304f822$var$resolve(id) {
    var resolved = $cc1a958bd304f822$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$cc1a958bd304f822$export$6503ec6e8aabbaf = $cc1a958bd304f822$var$register;
$cc1a958bd304f822$export$f7ad0328861e2f03 = $cc1a958bd304f822$var$resolve;

});

parcelRegister("lW4bD", function(module, exports) {
$parcel$export(module.exports, "getBundleURL", function () { return $ff82431dc1dc3028$export$bdfd709ae4826697; }, function (v) { return $ff82431dc1dc3028$export$bdfd709ae4826697 = v; });
// TODO: convert this file to ESM once HMR issues are resolved
var $ff82431dc1dc3028$export$5a759dc7a1cfb72a;
var $ff82431dc1dc3028$export$bdfd709ae4826697;
var $ff82431dc1dc3028$export$c9e73fbda7da57b6;
"use strict";
const $ff82431dc1dc3028$var$stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const $ff82431dc1dc3028$var$bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function $ff82431dc1dc3028$var$getBundleURLCached(id, inputError) {
    let value = $ff82431dc1dc3028$var$bundleURL[id];
    if (!value) {
        value = $ff82431dc1dc3028$var$getBundleURL(inputError);
        $ff82431dc1dc3028$var$bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function $ff82431dc1dc3028$var$getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function $ff82431dc1dc3028$var$getBundleURL(inputError) {
    try {
        throw inputError !== null && inputError !== void 0 ? inputError : new Error();
    } catch (err) {
        var matches = ('' + err.stack).match($ff82431dc1dc3028$var$stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ff82431dc1dc3028$var$getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function $ff82431dc1dc3028$var$getOrigin(url) {
    return new URL(url).origin;
}
$ff82431dc1dc3028$export$5a759dc7a1cfb72a = $ff82431dc1dc3028$var$getOrigin;
$ff82431dc1dc3028$export$bdfd709ae4826697 = $ff82431dc1dc3028$var$getBundleURLCached;
$ff82431dc1dc3028$export$c9e73fbda7da57b6 = $ff82431dc1dc3028$var$getBaseURL;

});

var $6554ba1679bdc03d$exports = {};


(parcelRequire("hwrhg")).register((parcelRequire("lW4bD")).getBundleURL('6R0re'), JSON.parse("[\"6R0re\",\"confirmation-page.c6a4b3fa.js\",\"ak5E0\",\"dev.ded552d9.js\",\"i45nz\",\"Intro.2e61f888.js\",\"hqm9L\",\"Outro.e0d3c97c.js\",\"1NzqT\",\"EN02.c24837a5.js\",\"3LNkL\",\"EN03.8088a872.js\",\"cvF1A\",\"EN04.23a926cc.js\",\"6NOTm\",\"DE02.d23b92df.js\",\"8X4tc\",\"DE03.de685750.js\",\"gx3Ew\",\"DE04.b8292dd2.js\",\"27aq8\",\"FR02.cbffaaae.js\",\"aXW7p\",\"FR03.6c2e3907.js\",\"37UKw\",\"FR04.04f8b3e1.js\",\"hGzhW\",\"ES02.a77cac55.js\",\"3okp2\",\"ES03.7d5bc21e.js\",\"2INS9\",\"ES04.9bcdf362.js\",\"g2fRD\",\"JA02.128650e6.js\",\"8YKY8\",\"JA03.b52f11d6.js\",\"hvW6L\",\"JA04.0d3d356f.js\",\"785R9\",\"PTBR02.a590dea0.js\",\"4D27a\",\"PTBR03.ebdc2dc9.js\",\"9GXnu\",\"PTBR04.dd625020.js\",\"iEO7H\",\"Intro.36d8dcae.js\",\"aEL7N\",\"Outro.c3de4baf.js\",\"hTSUY\",\"EN02.f3efb447.js\",\"9OP6g\",\"EN03.0ac49210.js\",\"3VxYf\",\"EN04.0dfe1612.js\",\"5XT98\",\"DE02.49a03125.js\",\"aE6v0\",\"DE03.7551904f.js\",\"4QXl3\",\"DE04.4131a45a.js\",\"8Ea94\",\"FR02.c6e6bf5f.js\",\"emEyD\",\"FR03.f2347c4a.js\",\"kx63i\",\"FR04.c49d6fdc.js\",\"35sEk\",\"ES02.d9afb835.js\",\"4QWKe\",\"ES03.9864bd47.js\",\"47Ukn\",\"ES04.3a8c92bf.js\",\"7uGtS\",\"JA02.5fcb1629.js\",\"h3uT4\",\"JA03.f8dbac78.js\",\"69cgK\",\"JA04.03b681d3.js\",\"6eOCB\",\"PTBR02.217a7445.js\",\"byXWj\",\"PTBR03.05c4189e.js\",\"d7vJk\",\"PTBR04.7ffad10b.js\",\"cbtdn\",\"1intro.fbbeabd5.js\",\"f5rBq\",\"2board.57840dc5.js\",\"12bjf\",\"3list.3f37fb33.js\",\"e2tMw\",\"4timeline.2fb4f4fc.js\",\"4S4JM\",\"4.5finishing-up.49ddf81d.js\",\"jAkx1\",\"5outro.277007ae.js\",\"bkALR\",\"1TAIL.1ef969b0.js\",\"bctkH\",\"1TOP.70b937d7.js\",\"90wN5\",\"2TAIL.83f6f8b7.js\",\"3ffgs\",\"2TOP.0d05d9a5.js\",\"kbJHr\",\"3TAIL.1c4add57.js\",\"bFbqo\",\"3TOP.a9a37923.js\",\"ewPGk\",\"4TAIL.106eb07f.js\",\"jZNI3\",\"4TOP.75266864.js\",\"3VFS4\",\"5REFLOOP.2909a2e9.js\",\"eKHnY\",\"6LOOP.9047a5ce.js\",\"8U9IU\",\"7OUTRO.24e4393d.js\",\"afYam\",\"SlackTeamsSpotlight.87d9929f.js\",\"2A8vK\",\"Ed.61b780ab.svg\",\"a6hlc\",\"Katina.9d77d506.svg\",\"bEhRS\",\"Myra.6a2e56a8.svg\",\"oEM2y\",\"Oliver.3c8edaab.svg\",\"aBy76\",\"slackSpotlight.c7655f37.svg\",\"c1x6w\",\"esm.7a9d621d.js\",\"2JqEa\",\"main.f4d42b58.js\",\"2NyJK\",\"main.a76e7f6b.js\",\"2yWIb\",\"main.ac1a5d02.js\",\"8lipP\",\"main.09231bf5.js\",\"4lKc9\",\"main.e1b0b915.js\",\"lxC77\",\"cs.d38b8d3c.js\",\"g5LOK\",\"da.f62b4ed7.js\",\"j932v\",\"de.f5f92930.js\",\"9u82F\",\"en.fffd40ca.js\",\"lIYZW\",\"en_GB.cbe8647a.js\",\"d0NCE\",\"en_ZZ.e770bd41.js\",\"djAyD\",\"es.c5d7bb0b.js\",\"75opk\",\"et.e58ea5cc.js\",\"kbrpe\",\"fi.eca85893.js\",\"e90kC\",\"fr.55de0f04.js\",\"ck0lB\",\"hu.9a356c22.js\",\"c26Eo\",\"is.aef18166.js\",\"3vJl0\",\"it.4dcf4052.js\",\"blAiY\",\"ja.b2b38f82.js\",\"kFtcB\",\"ko.a4ff2fae.js\",\"gmVIX\",\"nb.656e232f.js\",\"g1JpQ\",\"nl.d7b391c5.js\",\"9iF0X\",\"pl.11575567.js\",\"cssvc\",\"pt_BR.57044074.js\",\"kPGjP\",\"pt_PT.20563e8d.js\",\"lAqnd\",\"ro.435e93ff.js\",\"2WC7r\",\"ru.eedfb724.js\",\"dPjF4\",\"sk.7f20a49b.js\",\"bSmKT\",\"sv.442310a8.js\",\"bEBNB\",\"th.9984b4bb.js\",\"jhcJl\",\"tr.07531e62.js\",\"fIRMc\",\"uk.2220b801.js\",\"foJ5Y\",\"vi.039da127.js\",\"eoavR\",\"zh_TW.15e17e59.js\",\"g3JkR\",\"zh.5e9f9d16.js\",\"lwqvn\",\"cs.fa9599f3.js\",\"99TIA\",\"da.d7fa57c0.js\",\"hfLuR\",\"de.bbb5f04a.js\",\"k3VpT\",\"en_GB.86f8c6af.js\",\"3XxSb\",\"en.363ceb85.js\",\"aQLbr\",\"en_ZZ.b9b0f52e.js\",\"7tbKS\",\"es.a4e6b9c6.js\",\"h1ZGO\",\"fi.13ac4c22.js\",\"cEeFx\",\"fr.0675e0a6.js\",\"e2nN0\",\"hu.503af834.js\",\"bqC0Y\",\"it.92d2dd9a.js\",\"R2Nsp\",\"ja.e528a9c7.js\",\"fWRJl\",\"ko.c5529e20.js\",\"lEzBX\",\"nb.91df0d88.js\",\"dEFjl\",\"nl.f6f8774a.js\",\"dFBq0\",\"pl.9477db07.js\",\"iGxOA\",\"pt_BR.b91d849f.js\",\"iZEmO\",\"ru.691856b5.js\",\"cMU6L\",\"sv.4b4a6da5.js\",\"3nG0z\",\"tr.e3df1916.js\",\"6ztG6\",\"th.89a1501f.js\",\"1aebo\",\"uk.d3d080ae.js\",\"jIOVM\",\"vi.06876279.js\",\"l9LFQ\",\"zh_TW.628a4cac.js\",\"jae6V\",\"zh.c6eb5b5b.js\",\"aBYZ8\",\"cs.d1f9304c.js\",\"3ZzQ4\",\"da.61ed88cf.js\",\"7RvYL\",\"de.885a3163.js\",\"aGRWz\",\"en_GB.bed2d32e.js\",\"3bV83\",\"en.4d94faa6.js\",\"eZQaD\",\"en_ZZ.592bea42.js\",\"6ZZAD\",\"es.dc8255f7.js\",\"gSgHk\",\"et.078d1ba1.js\",\"cqMMB\",\"fi.2754ddf3.js\",\"ja8C2\",\"fr.c6fb7708.js\",\"l5zaw\",\"hu.7e65494b.js\",\"eyNDi\",\"is.a8711a68.js\",\"bPqAp\",\"it.8dad3f78.js\",\"8eOgr\",\"ja.571fbcc5.js\",\"jpm9w\",\"ko.a36850f1.js\",\"csUD9\",\"nb.8e9bec6a.js\",\"7DJy1\",\"nl.0e7fb810.js\",\"rhk3R\",\"pl.c97b0e53.js\",\"aRSus\",\"pt_BR.5f2658cc.js\",\"fyQSW\",\"pt_PT.85855929.js\",\"gv5NU\",\"ro.467221b8.js\",\"kT68O\",\"ru.c16d34c1.js\",\"6ZCmq\",\"sk.1a3b2911.js\",\"7lRCn\",\"sv.90296447.js\",\"eqJGl\",\"tr.1413ebc3.js\",\"d0IR5\",\"th.2c77e876.js\",\"dvvUW\",\"uk.d6c45ae1.js\",\"1bhYp\",\"vi.5ad03980.js\",\"5Wmew\",\"zh_TW.69003cec.js\",\"i0aES\",\"zh.558d45ee.js\",\"dtDSG\",\"WarningIllustration.bf07bd71.js\",\"k7Wll\",\"WarningIllustration.ec26752f.png\"]"));


//# sourceMappingURL=confirmation-page.runtime.98df5602.js.map
